// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
    --bg-colour: #17242D;
    --text-colour: white;
    --uiElements-colour: #21303a;
  }
 
  body {
    margin: 0;
    padding: 0;
    background-color: #cce8ff;
    /* overflow: hidden; */
    /* overflow-y: scroll;

    scrollbar-width: thin;  /* For Firefox */
  scrollbar-color: transparent transparent;  /* For Chrome, Edge, and Safa */
  }
  
    .z9NCPcGrOhI1tSuUVvTs {
      position: relative;
      /* width: 500px; */
      display: block;
      padding: 1% 1%;
      max-width: 600px !important;
    }
    /* 
    .button{
      border-radius: 80px;
      border: double 4px transparent;
      background-image: linear-gradient(rgb(0, 0, 0), rgb(0, 0, 0)), radial-gradient(circle at top left, #5a81fffd, #ff1c1c);
      background-origin: border-box;
      background-clip: padding-box, border-box;
      font-size: 20px;
      cursor: pointer;
      padding: 10px 15px;
      align-items: center;
      justify-content: center;
      color: white;
      border: 3px solid black;
      border-radius: 100px;
      background: black;
      color: white;
      border: none;
    }
    */
    
    .QB0ZTd4udxF_jjTTkBzQ {
      position: relative;
      clear:left;
      display: block;
      text-align: center;
    }
  
  
  .BmaQR5b9OBB4zuhONCSA {
    width: 100%;
    height: 100%;
    position: relative;
    /* background-color: #cce8ff; */
  }
  
    h1,
    p {
      position: relative;
      z-index: 1;
      text-align: center;
    }
    
    @keyframes Slk_Ho1SThc6mBO_BFcL {
      0% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
      100% {
        transform: translateY(0);
      }
    }
    .E5LrJ8yZfNBWoUuX9CjB {
      animation-name: Slk_Ho1SThc6mBO_BFcL;
      animation-duration: 3s;
      animation-iteration-count: infinite;
      animation-timing-function: ease-in-out;
    }
    
   
    
   
    .s8jGzRjE1Aek9MRKZSlL{
      width: 19px;
      height: 24;
      float:left;
    }
    
    .fyDYevxMi46deeYvcS44 {
      display: flex;
      align-items: center;
      justify-content: center;
      /* outline: 1px; */
      flex-wrap: wrap;
      flex-direction: row;
      align-content: center;
      text-align: center;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    
    .lDgHJs2ogAKasZ237DwW.x1s6W5ilVi8HheuIkn0y {
      color: blue;
    }
    /* #imageCarousel{
      width: 100%;
      position: relative;
      display: block;
      padding: 1% 1%;
      border: 1px;
      border: 3px solid #ffffff;
      margin-top: 10px;
    }   */
    
    h1, h2, h3, h4 {
      font-family: 'Roboto';
      color: var(--text-colour);
    }   
    
    
    .rOSWWkJmE3fBlV7y2mZV {
    display: block; /* remove any default spacing and padding */
    /* max-width: 90%; */
    height: auto; /* maintain aspect ratio */
    padding-right:20px;
    
  }
  
  .SdMygDpLt64XO7Xmc292 {
    display: block; /* remove any default spacing and padding */
    /* max-width: 40%; ensure the images scale properly */
    height: auto; /* maintain aspect ratio */
    padding: 20px;
    
  }
  
  .cPahBFI_QtAo6Eegnv_s{
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 30%;
      /* height: auto; */
      border: 3px solid var(--text-colour);
    }
  
  hr { 
    /* border: 3px solid #ffffff; */
    width: 20%;
    border-color: "blue";
  } 

  .Tq_CUGAzvJe0DT3SSHIf{
    width: 40%;
    /* position: relative;
    display: block; */
    padding: 1% 1%;
    border: 1px;
    border: 3px solid #ffffff;
    margin-top: 10px;
  }

  @media (max-width: 600px) {
    h3 {
      font-size: 200px; /* Adjust the increased font size as needed */
    }
  }

  

 

  

  @media (max-width: 576px) {
    ._zC0xsxRSHwAajSMcnFc {
      max-width: 100%;
    }
  }

  .fIi7e8KBvdQ3M95y9Jxx{
    width: 400px; /* Adjust the width as per your requirements */
    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    justify-content: center; /* Horizontally center the elements */
  }

  .fIi7e8KBvdQ3M95y9Jxx p{
    margin-right: 10px;
  }

  .oCUQY2ijKRbGmYC3eZrG{
    /* color: transparent; */
    background:  #66baff;
    /* border-radius: 10px; */
    padding: 10px 10px 0px 0px;
    margin-top: 10px;
    margin-bottom: 10px;
    /* margin: 1% 1% 0 0 !important; */
    justify-content: center;
    border: 3px solid black;
    border-radius: 20px;
    margin: 10px;
  }

  @media (max-width: 650px) {
    .oCUQY2ijKRbGmYC3eZrG{
      background-color: #b3ddff;
      border-radius: 10px;
      padding: 10px;
      margin-left: 15% !important;
      margin-right: 15% !important;
      margin-top: 10px;
      margin-bottom: 10px;
      justify-content: center;
    }

    .z9NCPcGrOhI1tSuUVvTs {
      position: relative;
      width: 350px;
      display: block;
      padding: 1% 1%;
    }
  }

  h1 {
    display: block;
    font-size: 64px;
    font-family: sans-serif;
  }

  .aAc8PZOqRNO8Kql5Hrgl{
    border-style: solid;
    border-width: 10px;
    border-top-width: 0;
    border-bottom-width: 0;
    padding-left: 10%;
    padding-right: 10%;
    background-color: black;
    height: 100px;
    justify-content: center !important;
    align-items: center;
    display: flex;
  }`, "",{"version":3,"sources":["webpack://./src/Pronounce.module.css"],"names":[],"mappings":";AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,4BAA4B;EAC9B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB;;4CAEwC;EAC1C,wCAAwC,GAAG,+BAA+B;EAC1E;;IAEE;MACE,kBAAkB;MAClB,kBAAkB;MAClB,cAAc;MACd,cAAc;MACd,2BAA2B;IAC7B;IACA;;;;;;;;;;;;;;;;;;;KAmBC;;IAED;MACE,kBAAkB;MAClB,UAAU;MACV,cAAc;MACd,kBAAkB;IACpB;;;EAGF;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;EACjC;;IAEE;;MAEE,kBAAkB;MAClB,UAAU;MACV,kBAAkB;IACpB;;IAEA;MACE;QACE,wBAAwB;MAC1B;MACA;QACE,4BAA4B;MAC9B;MACA;QACE,wBAAwB;MAC1B;IACF;IACA;MACE,oCAAqB;MACrB,sBAAsB;MACtB,mCAAmC;MACnC,sCAAsC;IACxC;;;;;IAKA;MACE,WAAW;MACX,UAAU;MACV,UAAU;IACZ;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,eAAe;MACf,mBAAmB;MACnB,qBAAqB;MACrB,kBAAkB;MAClB,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;IACA;;;;;;;;SAQK;;IAEL;MACE,qBAAqB;MACrB,yBAAyB;IAC3B;;;IAGA;IACA,cAAc,EAAE,2CAA2C;IAC3D,oBAAoB;IACpB,YAAY,EAAE,0BAA0B;IACxC,kBAAkB;;EAEpB;;EAEA;IACE,cAAc,EAAE,2CAA2C;IAC3D,qDAAqD;IACrD,YAAY,EAAE,0BAA0B;IACxC,aAAa;;EAEf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;MACR,kBAAkB;MAClB,oCAAoC;IACtC;;EAEF;IACE,+BAA+B;IAC/B,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV;qBACiB;IACjB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB,EAAE,6CAA6C;IACjE;EACF;;;;;;;;EAQA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,YAAY,EAAE,8CAA8C;IAC5D,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,uBAAuB,EAAE,qCAAqC;EAChE;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE;MACE,yBAAyB;MACzB,mBAAmB;MACnB,aAAa;MACb,2BAA2B;MAC3B,4BAA4B;MAC5B,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,cAAc;MACd,cAAc;IAChB;EACF;;EAEA;IACE,cAAc;IACd,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;EACf","sourcesContent":["\n:root {\n    --bg-colour: #17242D;\n    --text-colour: white;\n    --uiElements-colour: #21303a;\n  }\n \n  body {\n    margin: 0;\n    padding: 0;\n    background-color: #cce8ff;\n    /* overflow: hidden; */\n    /* overflow-y: scroll;\n\n    scrollbar-width: thin;  /* For Firefox */\n  scrollbar-color: transparent transparent;  /* For Chrome, Edge, and Safa */\n  }\n  \n    .logoBanner {\n      position: relative;\n      /* width: 500px; */\n      display: block;\n      padding: 1% 1%;\n      max-width: 600px !important;\n    }\n    /* \n    .button{\n      border-radius: 80px;\n      border: double 4px transparent;\n      background-image: linear-gradient(rgb(0, 0, 0), rgb(0, 0, 0)), radial-gradient(circle at top left, #5a81fffd, #ff1c1c);\n      background-origin: border-box;\n      background-clip: padding-box, border-box;\n      font-size: 20px;\n      cursor: pointer;\n      padding: 10px 15px;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      border: 3px solid black;\n      border-radius: 100px;\n      background: black;\n      color: white;\n      border: none;\n    }\n    */\n    \n    .headings {\n      position: relative;\n      clear:left;\n      display: block;\n      text-align: center;\n    }\n  \n  \n  .App {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    /* background-color: #cce8ff; */\n  }\n  \n    h1,\n    p {\n      position: relative;\n      z-index: 1;\n      text-align: center;\n    }\n    \n    @keyframes float {\n      0% {\n        transform: translateY(0);\n      }\n      50% {\n        transform: translateY(-10px);\n      }\n      100% {\n        transform: translateY(0);\n      }\n    }\n    .circle {\n      animation-name: float;\n      animation-duration: 3s;\n      animation-iteration-count: infinite;\n      animation-timing-function: ease-in-out;\n    }\n    \n   \n    \n   \n    .icon{\n      width: 19px;\n      height: 24;\n      float:left;\n    }\n    \n    .box {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      /* outline: 1px; */\n      flex-wrap: wrap;\n      flex-direction: row;\n      align-content: center;\n      text-align: center;\n      margin-bottom: 10px;\n      margin-top: 10px;\n    }\n    \n    .spinner-border.custom-spinner {\n      color: blue;\n    }\n    /* #imageCarousel{\n      width: 100%;\n      position: relative;\n      display: block;\n      padding: 1% 1%;\n      border: 1px;\n      border: 3px solid #ffffff;\n      margin-top: 10px;\n    }   */\n    \n    h1, h2, h3, h4 {\n      font-family: 'Roboto';\n      color: var(--text-colour);\n    }   \n    \n    \n    .leftAlign {\n    display: block; /* remove any default spacing and padding */\n    /* max-width: 90%; */\n    height: auto; /* maintain aspect ratio */\n    padding-right:20px;\n    \n  }\n  \n  .rightAlign {\n    display: block; /* remove any default spacing and padding */\n    /* max-width: 40%; ensure the images scale properly */\n    height: auto; /* maintain aspect ratio */\n    padding: 20px;\n    \n  }\n  \n  .gif{\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width: 30%;\n      /* height: auto; */\n      border: 3px solid var(--text-colour);\n    }\n  \n  hr { \n    /* border: 3px solid #ffffff; */\n    width: 20%;\n    border-color: \"blue\";\n  } \n\n  .carousel{\n    width: 40%;\n    /* position: relative;\n    display: block; */\n    padding: 1% 1%;\n    border: 1px;\n    border: 3px solid #ffffff;\n    margin-top: 10px;\n  }\n\n  @media (max-width: 600px) {\n    h3 {\n      font-size: 200px; /* Adjust the increased font size as needed */\n    }\n  }\n\n  \n\n \n\n  \n\n  @media (max-width: 576px) {\n    .text-wrap {\n      max-width: 100%;\n    }\n  }\n\n  .textBox{\n    width: 400px; /* Adjust the width as per your requirements */\n    /* overflow: hidden; */\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: flex;\n    justify-content: center; /* Horizontally center the elements */\n  }\n\n  .textBox p{\n    margin-right: 10px;\n  }\n\n  .contained{\n    /* color: transparent; */\n    background:  #66baff;\n    /* border-radius: 10px; */\n    padding: 10px 10px 0px 0px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    /* margin: 1% 1% 0 0 !important; */\n    justify-content: center;\n    border: 3px solid black;\n    border-radius: 20px;\n    margin: 10px;\n  }\n\n  @media (max-width: 650px) {\n    .contained{\n      background-color: #b3ddff;\n      border-radius: 10px;\n      padding: 10px;\n      margin-left: 15% !important;\n      margin-right: 15% !important;\n      margin-top: 10px;\n      margin-bottom: 10px;\n      justify-content: center;\n    }\n\n    .logoBanner {\n      position: relative;\n      width: 350px;\n      display: block;\n      padding: 1% 1%;\n    }\n  }\n\n  h1 {\n    display: block;\n    font-size: 64px;\n    font-family: sans-serif;\n  }\n\n  .lowerThird{\n    border-style: solid;\n    border-width: 10px;\n    border-top-width: 0;\n    border-bottom-width: 0;\n    padding-left: 10%;\n    padding-right: 10%;\n    background-color: black;\n    height: 100px;\n    justify-content: center !important;\n    align-items: center;\n    display: flex;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoBanner": `z9NCPcGrOhI1tSuUVvTs`,
	"headings": `QB0ZTd4udxF_jjTTkBzQ`,
	"App": `BmaQR5b9OBB4zuhONCSA`,
	"circle": `E5LrJ8yZfNBWoUuX9CjB`,
	"float": `Slk_Ho1SThc6mBO_BFcL`,
	"icon": `s8jGzRjE1Aek9MRKZSlL`,
	"box": `fyDYevxMi46deeYvcS44`,
	"spinner-border": `lDgHJs2ogAKasZ237DwW`,
	"custom-spinner": `x1s6W5ilVi8HheuIkn0y`,
	"leftAlign": `rOSWWkJmE3fBlV7y2mZV`,
	"rightAlign": `SdMygDpLt64XO7Xmc292`,
	"gif": `cPahBFI_QtAo6Eegnv_s`,
	"carousel": `Tq_CUGAzvJe0DT3SSHIf`,
	"text-wrap": `_zC0xsxRSHwAajSMcnFc`,
	"textBox": `fIi7e8KBvdQ3M95y9Jxx`,
	"contained": `oCUQY2ijKRbGmYC3eZrG`,
	"lowerThird": `aAc8PZOqRNO8Kql5Hrgl`
};
export default ___CSS_LOADER_EXPORT___;
